import { observer } from 'mobx-react';
import * as React from 'react';
import DragIndicatorIcon from '../../../../../../../Cutesies/DragIndicatorIcon';
import { ExperienceResource } from '../../../../../../Types';
import LearningCollectionEditStore from '../../../../Store';
import { ModifiableExperiencesContext } from '../../../../../Types';
import ExperienceRowItems from '../Experiences/ExperienceRowItems';

interface Props {
  context: ModifiableExperiencesContext;
  store: LearningCollectionEditStore;
  experienceResource: ExperienceResource;
}

const ExperienceRowItemsWithHandlers: React.FC<Props> = ({
  context,
  store,
  experienceResource,
}) => {
  return (
    <>
      <td className="pt-1">
        <input
          className="h-5 w-4 cursor-pointer text-teal-600"
          type="checkbox"
          name="modifyExperience"
          checked={false}
          onChange={() => store.addExperienceStore(context, experienceResource)}
        />
      </td>
      <td className="px-2 pt-1">
        <div className="inline-block cursor-not-allowed opacity-50">
          <DragIndicatorIcon />
        </div>
      </td>
      <ExperienceRowItems experienceResource={experienceResource} />
    </>
  );
};

export default observer(ExperienceRowItemsWithHandlers);
